import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  evaluateAdsensePageSafety,
  forceAdsensePaused,
  isAdsenseCandidateRoute,
  setAdsensePageSafety,
} from '../services/ads/adsenseSafetyGate.js';

export function AdSenseSafetyGate() {
  const { pathname } = useLocation();

  useEffect(() => {
    let disposed = false;
    let scheduled = 0;

    const evaluate = () => {
      if (disposed) return;
      if (scheduled) window.cancelAnimationFrame(scheduled);
      scheduled = window.requestAnimationFrame(() => {
        scheduled = 0;
        if (disposed) return;
        setAdsensePageSafety(evaluateAdsensePageSafety({
          pathname,
          root: document,
          visibilityState: document.visibilityState,
        }));
      });
    };

    // Every route starts fail-closed. Only a loaded, actively playing AVOD surface can reopen Google requests.
    forceAdsensePaused(isAdsenseCandidateRoute(pathname) ? 'awaiting-avod-surface' : 'forbidden-route');
    evaluate();

    const observer = new MutationObserver(evaluate);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-ad-mode', 'data-playback-id', 'data-avod-phase', 'data-preroll-complete', 'data-adsense-status'],
    });
    document.addEventListener('visibilitychange', evaluate);

    return () => {
      disposed = true;
      if (scheduled) window.cancelAnimationFrame(scheduled);
      observer.disconnect();
      document.removeEventListener('visibilitychange', evaluate);
      forceAdsensePaused('route-unmounted');
    };
  }, [pathname]);

  return null;
}
